import backend from "../api";
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  PARTICIPATING_MERCHANT_REQUEST,
  PARTICIPATING_MERCHANT_SUCCESS,
  PARTICIPATING_MERCHANT_ERROR,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
} from "../constants/userConstants";

export const login = (user) => async (dispatch) => {
  try {
    dispatch({ type: USER_LOGIN_REQUEST });
    const { data } = await backend.post("/user/login", user);
    if (data.data.user.role === "merchant") {
      localStorage.setItem("userInfo", JSON.stringify(data.data));
      sessionStorage.setItem("token", data.token);
      dispatch({ type: USER_LOGIN_SUCCESS, payload: data.data });
    } else {
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: "Only Merchant can log in here!",
      });
    }
  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const register = (user) => async (dispatch) => {
  try {
    dispatch({ type: USER_REGISTER_REQUEST });
    const { data } = await backend.post("/user/create/merchant/eksplode_code", user);
    dispatch({ type: USER_REGISTER_SUCCESS, payload: data.data });
  } catch (error) {
    let message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: USER_REGISTER_FAIL,
      payload: message,
    });
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("userInfo");
  sessionStorage.removeItem("token");
  dispatch({ type: USER_LOGOUT });
  document.location.href = "/";
};

export const requestParticipating = (body) => async (dispatch) => {
  try {
    dispatch({ type: PARTICIPATING_MERCHANT_REQUEST });
    const { data } = await backend.post(`/requestedmerchants`, body);
    dispatch({ type: PARTICIPATING_MERCHANT_SUCCESS, payload: data.data });
  } catch (error) {
    let message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: PARTICIPATING_MERCHANT_ERROR,
      payload: message,
    });
  }
};

export const forgetPassword = (email) => async (dispatch) => {
  try {
    dispatch({ type: FORGOT_PASSWORD_REQUEST });
    // const { data } = await backend.post(`/user/password/forgot`, email);
    const { data } = await backend.post(`/auth/password/forgot`, email);
    console.log(data);
    dispatch({
      type: FORGOT_PASSWORD_SUCCESS,
      payload: data.message,
    });
  } catch (error) {
    let message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: FORGOT_PASSWORD_FAIL,
      payload: message,
    });
  }
};

export const resetPassword = (body) => async (dispatch) => {
  try {
    dispatch({ type: RESET_PASSWORD_REQUEST });
    // const { data } = await backend.put(`/user/password/reset/${body.token}`, {
    //   password: body.password,
    // });
    const { data } = await backend.put(`/auth/password/reset/${body.token}`, {
      password: body.password,
    });
    dispatch({ type: RESET_PASSWORD_SUCCESS, payload: data.message });
  } catch (error) {
    let message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: RESET_PASSWORD_FAIL,
      payload: message,
    });
  }
};
